import BasicResource from '@/api/resource';

class UsersResource extends BasicResource {

    constructor () {
        super('users');
    }

    dict (params) {
        return this.client.request ({
            method: 'get',
            path: '/upyield/v1/dict/users',
            params: { ...params, limit: -1 },
        });
    }

    stats (id) {
        return this.client.request ({
            method: 'get',
            path: `/upyield/v1/users/${id}/stats`,
        });
    }

    delete (id, params = {}) {
        return this.client.request ({
            method: 'delete',
            path: `/upyield/v1/users/${id}`,
            params: { ...params },
        });
    }
}

export default new UsersResource;
